import { render, staticRenderFns } from "./invite-person.vue?vue&type=template&id=99703b90&scoped=true&"
import script from "./invite-person.vue?vue&type=script&lang=js&"
export * from "./invite-person.vue?vue&type=script&lang=js&"
import style0 from "./invite-person.vue?vue&type=style&index=0&id=99703b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99703b90",
  null
  
)

export default component.exports